/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

/** Custom Hooks */
import useDebounce from "../../app/customHooks/useDebounce";

/** Common Components */
import MolGrid from "../../components/grid/MolGrid";
import CardSection from "../../components/ui/card/CardSection";

/** Common Services & Data Files */
import { encryptUrlData } from "../../services/CryptoService";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";

/** Configuration Files */
import { EmailTemplateGridConfig } from "./features/config/EmailTemplate.data";

/** Common Components */
import {
  useDeleteEmailTemplateMutation,
  useGetEmailTemplateMutation,
} from "../../app/services/emailTemplateAPI";
import "./EmailTemplate.scss";

const EmailTemplate = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 300);

  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const molGridRef = useRef();
  const { confirm } = SwalAlert();
  const navigate = useNavigate();

  const [getEmailTemplateList, {
    isLoading: isListLoading,
    isSuccess: isListSuccess,
    data: emailTemplateData,
  },] = useGetEmailTemplateMutation();

  const [deleteEmail, {
    isLoading: isDeleting,
    isSuccess: isDeleteSuccess,
    data: deleteEmailData
  }] = useDeleteEmailTemplateMutation();

  const getEmailTemplate = (pageObject) => {
    getEmailTemplateList(pageObject);
  };

  const addEmailTemplate = () => {
    navigate("/admin/AddEmailTemplate");
  };

  const handlePageChange = (page) => {
    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      filters: { searchText: debouncedSearch },
    };
    getEmailTemplate(request);
  };

  const onEditAction = (data) => {
    navigate(`/admin/EditEmailTemplate/${encryptUrlData(data.templateId)}`);
  };

  const onDeleteAction = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteEmail(data.templateId);
      }
    });
  };

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteAction,
  };
  // Delete UseEffect

  useEffect(() => {
    if (isDeleteSuccess && deleteEmailData) {
      ToastService.success(deleteEmailData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: debouncedSearch },
      };
      getEmailTemplate(request);
    }
  }, [isDeleteSuccess, deleteEmailData]);

  useEffect(() => {
    if (isListSuccess && emailTemplateData) {
      if (emailTemplateData) {
        setDataSource(emailTemplateData.dataSource);
      }
      if (emailTemplateData.totalRecord) {
        setTotalRowCount(emailTemplateData.totalRecord);
      }
    }
  }, [isListSuccess, emailTemplateData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: debouncedSearch },
      };
      getEmailTemplate(request);
    }
  }, [debouncedSearch]);

  return (
    <div className="email-list center-top-space">
      <CardSection
        isContentLoading={isListLoading || isDeleting}
        cardTitle={"Email Template list"}
        rightButton={true}
        buttonClassName="theme-btn"
        titleButtonClick={addEmailTemplate}
        buttonText="Email Template"
        textWithIcon={true}
        iconName="material-symbols:add-rounded"
        fontIcon={true}
        searchInputName="Search by Name"
        searchInput={true}
        handleChange={handleOnSearchChange}
      >
        <div className="table-grid">
          <MolGrid
            ref={molGridRef}
            configuration={EmailTemplateGridConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={{
              totalCount: totalRowCount,
              pageSize: 20,
              currentPage: 1,
            }}
            isLoading={isListLoading}
            onActionChange={actionHandler}
            onPageChange={handlePageChange}
          />
        </div>
      </CardSection>
    </div>
  );
};
export default EmailTemplate;
